export default class ChatMessageType{
  static TEXT = 'TEXT';
  static ADMIN = 'ADMIN';
  static FILE = 'FILE';
}
